module.exports = {
  data() {
    return {
      clients: [],
      errors: {},
      loading: false
    };
  },

  methods: {
    getClients() {
      axios.get('/api/clients')
        .then(({data}) => this.clients = data)
        .catch(({error}) => console.log(error));
    },

    queueExport() {
      this.loading = true;
      let query = this.convertToQueryString();
      axios.get(`/api/reports/${this.form.client}/${this.form.type}-metrics/?email=true&${query}`)
        .then(({data}) => {
          Bus.$emit('hide-export-builder');
          Bus.$emit('show-success-alert', data.message);
          this.reset();
          this.loading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false
        });
    },

    convertToQueryString() {
      let form = this.form;
      return Object.keys(form).reduce(function(a,k){a.push(k+'='+encodeURIComponent(form[k]));return a},[]).join('&');
    },
  }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/exports/mixins/Exports.js